/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Tournament_Format_Forbids_DecksInputs */



/**
* | output |
* | --- |
* | "Storyline events take no decklist" |
*
* @param {Err_Tournament_Format_Forbids_DecksInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_format_forbids_decks = /** @type {((inputs?: Err_Tournament_Format_Forbids_DecksInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_Format_Forbids_DecksInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Les événements Storyline n'acceptent aucune decklist")
	if (locale === "es") return /** @type {LocalizedString} */ ("Los eventos Storyline no admiten lista de mazo")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Eventos Storyline não aceitam lista de deck")
	if (locale === "it") return /** @type {LocalizedString} */ ("Gli eventi Storyline non accettano liste del mazzo")
	return /** @type {LocalizedString} */ ("Storyline events take no decklist")
});